// extracted by extract-css-chunks-webpack-plugin
module.exports = {"backButton":"_1aWgha","button":"_2lbVwU","closeButton":"_212M_m","content":"_2Yftdl","navContainer":"_2obKQa"};